import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { DatePicker, Loadable, EntitySelector } from "components/support";

import Moment from "moment";

class CustomerSalesReportFilter extends Component {
  static sReportTypes = [{ value: "summary", label: "Resumido" }];

  handleChange = ({ startDate, endDate, reportType }) => {
    const { onChange } = this.props;
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    if (reportType) {
      options.reportType = reportType;
    }

    onChange(options);
  };

  render() {
    const {
      loading,
      filters,
      customerSearchOptions,
      customer,
      onSelectCustomer,
      customerSelectedDataTable
    } = this.props;
    const { dateFrom, dateTo } = filters;
    const customerName = customerSelectedDataTable.name || customer.name || "";
    const customerIdentification =
      customerSelectedDataTable.uuid || customer.identification || "";
    const customerEmail = customer.email || "";

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={loading}>
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12}>
              <DatePicker
                multiple
                label="Período"
                modal
                fullWidth
                startDate={dateFrom}
                endDate={dateTo}
                onChange={({ startDate, endDate }) =>
                  this.handleChange({ startDate, endDate })
                }
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <EntitySelector
                nullSelection={{ name: "", uuid: null }}
                label="Cliente"
                title="Selecionar Cliente"
                value={customerName || customerIdentification || customerEmail}
                searchOptions={customerSearchOptions}
                onSelect={customer => onSelectCustomer(customer)}
                parser={customer => ({
                  key: customer.uuid,
                  title: customer.identifier()
                })}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default CustomerSalesReportFilter;



// WEBPACK FOOTER //
// ./src/components/app/management/customer-sales-report/filter/index.jsx